import { render } from "./Variants.vue?vue&type=template&id=601c5d88&scoped=true"
import script from "./Variants.vue?vue&type=script&lang=js"
export * from "./Variants.vue?vue&type=script&lang=js"

import "./Variants.vue?vue&type=style&index=0&id=601c5d88&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601c5d88"]])

export default __exports__